import { useState, useCallback } from 'react';

/**
 * 에디터 내용 관리 커스텀 훅
 * @returns {Object} 에디터 상태 및 핸들러
 */
function useEditorContent() {
  const [editorContent, setEditorContent] = useState('');

  const handleEditorChange = useCallback(
    function (data) {
      // 이전 값과 동일하면 업데이트하지 않음 (무한 루프 방지)
      setEditorContent(function (prev) {
        if (prev === data) {
          return prev;
        }
        return data;
      });
    },
    [], // 의존성 배열이 비어있으므로 함수는 한 번만 생성됨
  );

  return {
    editorContent,
    setEditorContent,
    handleEditorChange,
  };
}

export default useEditorContent;
